 
import { Http } from "../Http";
export class forgotpasswordApi {

 


    public static saveforgotpassword(input: any) {
        
        var obj=JSON.stringify(input);
        var url="api/passwordreset";  
        const resultMethod = Http.axios().post(url, obj,
          {
            headers: {
              'Content-Type': 'application/json',
              "Access-Control-Allow-Origin": "*",
              "Access-Control-Allow-Methods": "*",
              "Access-Control-Allow-Headers": "*"
            }
          })
          .then(res => {
         
            return res;
          }).catch((e: any) => {
        
            return e.response;
          });
        return resultMethod;
}

public static saveforgotusername(input: any) {
        
 

  var url="api/forgotUserName?emailId="+input.userEmail;  
 
  const resultMethod = Http.axios().get(url, 
    {
      headers: {
        'Content-Type': 'application/json',
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "*",
        "Access-Control-Allow-Headers": "*"
      }
    })
    .then(res => {
   
      return res;
    }).catch((e: any) => {
  
      return e.response;
    });
  return resultMethod;
}


}